import React, { useState, useEffect } from 'react';
import PageTransition from '../components/PageTransition';
import ncb from '../db/ncb';

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    setImages(ncb.gallery.list());
  }, []);

  return (
    <PageTransition>
      <div className="bg-brand-cream pt-16 pb-12 text-center px-4">
        <span className="font-script text-3xl text-brand-sage mb-2 block">Visual Tour</span>
        <h1 className="font-serif text-4xl md:text-5xl text-brand-dark">Gallery</h1>
      </div>

      <div className="container mx-auto px-4 max-w-7xl pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[250px] md:auto-rows-[280px]">
          {images.map((img) => (
            <div key={img.id} className={`relative overflow-hidden rounded-sm group ${img.span_class || ''}`}>
              <div className="absolute inset-0 bg-brand-dark/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 flex items-center justify-center">
                <span className="text-white font-serif tracking-widest uppercase text-sm opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0 text-center px-4">
                  {img.alt_text}
                </span>
              </div>
              <img src={img.url} alt={img.alt_text} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
          ))}
        </div>
      </div>
    </PageTransition>
  );
};

export default Gallery;